import { TableRow } from 'src/components/PortalList/PortalList.styles';
import styled from 'styled-components';
import { TableTitle } from 'src/components/Table/TableTitle';
import { mediaMaxWidth2 } from 'src/styles/layout';
import { SigningCaseStatus } from '../SigningCaseStatus';
import {
  getBackgroundColor,
  getBackgroundHoverColor,
} from 'src/utils/getBackgroundColor';

export const Row = styled(TableRow)`
  background-color: ${getBackgroundColor};

  &:hover {
    background-color: ${getBackgroundHoverColor};
  }
`;

export const Title = styled(TableTitle)`
  ${mediaMaxWidth2.tabletSmall`
    font-size: 1.2em;
  `}
`;

export const AgreementStatus = styled(SigningCaseStatus)`
  color: ${props => props.color};
`;

export const AgreementStatusMobile = styled(SigningCaseStatus)`
  display: inline-block;
  padding: 10px 5px;
  width: 50%;
  text-align: right;
  color: ${props => props.color} ${mediaMaxWidth2.tabletSmall`
    font-size: 1.2em;
  `};
`;
